import {createRouter, createWebHistory} from 'vue-router'
import VisPageBase from '@/pages/_pageBase/VisPageBase'

const routes = [
    // {
    //     path: '/teste',
    //     name: 'teste',
    //     meta: {
    //         requiresAuth: true,
    //         funcionaOffline: true,
    //         page: false,
    //         nav: true
    //     },
    //     //component: () => import( /* webpackChunkName: "penelope" */ '@/pages/_interno/testes/Icones/Icones.vue')
    //     component: () => import( /* webpackChunkName: "penelope" */ '@/pages/_interno/testes/UsuariosOnline.vue')
    // },

    {
        path: '/integracao-offline',
        name: 'integracao-offline',
        meta: {
            requiresAuth: false,
            funcionaOffline: true,
            permiteIntegracao: true
        },
        component: () => import(/* webpackChunkName: "marizete" */ '@/pages/_pageBase/IntegracaoOffline')
    },

    {
        path: '/login',
        name: 'login',
        component: () => import( /* webpackChunkName: "dolores" */ '@/pages/login/Login.vue')

    },
    {
        path: '/recuperarSenha',
        name: 'recuperarSenha',
        component: () => import( /* webpackChunkName: "dolores" */ '@/pages/login/RecuperarSenha.vue')

    },

    {
        path: '/go',
        name: 'go',
        component: () => import( /* webpackChunkName: "lucineide" */ '@/pages/goToPanel/goToPanel.vue'),
        meta: {
            requiresAuth: false,
            integracao: true,
            permiteIntegracao: true
        },
    },
    {
        path: '/resetarSenha/:chave?',
        name: 'resetarSenha',
        component: () => import( /* webpackChunkName: "rosicleide" */ '@/pages/login/ResetarSenha.vue'),
        meta: {
            requiresAuth: false,
        }
    },

    {
        path: '/',
        meta: {
            requiresAuth: true,
            page: true,
            nav: true
        },
        children: [
            {
                path: 'offline',
                name: 'offline',
                meta: {
                    requiresAuth: false,
                    funcionaOffline: true,
                    page: true,
                    nav: true
                },
                component: () => import( /* webpackChunkName: "penelope" */ '@/pages/_pageBase/Offline')
            },
            {
                path: '',
                name: 'home',
                meta: {
                    requiresAuth: true,
                    page: true,
                    nav: true,
                },
                component: () => import( /* webpackChunkName: "helga" */ '@/pages/home/PageHome')
            },
            {
                path: 'dev',
                name: 'dev',
                meta: {
                    requiresAuth: true,
                    // page: true,
                    nav: true
                },
                component: () => import( /* webpackChunkName: "doralice" */ '@/pages/dev/PageDev')
            },
            {
                path: '/paineis-dev',
                name: 'paineis-dev',
                meta: {
                    requiresAuth: true,
                    page: true,
                    nav: true,
                    somenteUsuarioDev: true,
                },
                // component: () => import( /* webpackChunkName: "abigail" */ '@/pages/painel/PagePaineisOld')
                component: () => import( /* webpackChunkName: "abigail" */ '@/pages/painel/PagePaineisDev')
            },
            {
                path: 'painel/:id',
                name: 'painel',
                meta: {
                    requiresAuth: true,
                    rotaSalva: true,
                    funcionaOffline: true,
                    page: false,
                    nav: false,
                    navMobile: true,
                    permiteIntegracao: true
                },
                component: () => import( /* webpackChunkName: "persefone" */ '@/pages/painel/PagePainel'),

            },
            {
                path: 'painel/:id/:execucaoAnalitica',
                name: 'painelAnalitico',
                meta: {
                    requiresAuth: true,
                    rotaSalva: true,
                    funcionaOffline: true,
                    page: false,
                    nav: false
                },
                props: (route) => ({requisicaoExterna: route.query.req}),
                component: () => import( /* webpackChunkName: "persefone" */ '@/pages/painel/PagePainel')
            },
            {
                path: 'dev.painel/',
                name: 'dev-painel-dev',
                meta: {
                    requiresAuth: true,
                    somenteUsuarioDev: true,
                },
                component: () => import( /* webpackChunkName: "potira" */ '@/pages/dev/painel/PagePainel')
            },

            {
                path: 'dev.painel/:id',
                name: 'dev-painel',
                meta: {
                    requiresAuth: true,
                    rotaSalva: true,
                    nav: true,
                    menuVisible: false,
                    isFullPage: false,
                    page: false,
                    somenteUsuarioDev: true
                },
                component: () => import( /* webpackChunkName: "potira" */ '@/pages/dev/painel/PagePainel')
            },
            {
                path: '/reports-dev',
                name: 'reports-dev',
                meta: {
                    requiresAuth: true,
                    page: true,
                    nav: true,
                    somenteUsuarioDev: true
                },
                component: () => import( /* webpackChunkName: "maria" */ '@/pages/report/PageReportsDev')
            },
            {
                path: 'dev.report/:id',
                name: 'dev-report',
                meta: {
                    requiresAuth: true,
                    rotaSalva: true,
                    nav: true,
                    menuVisible: false,
                    isFullPage: false,
                    page: false,
                    somenteUsuarioDev: true
                },
                component: () => import( /* webpackChunkName: "marta" */ '@/pages/dev/report/Index.vue')
            },
            {
                path: 'report/:id',
                name: 'report',
                meta: {
                    requiresAuth: true,
                    rotaSalva: true,
                    nav: true,
                    menuVisible: false,
                    isFullPage: false,
                    page: false,
                    permiteIntegracao: true
                },
                component: () => import( /* webpackChunkName: "marta" */ '@/pages/report/Index.vue')
            },
            {
                path: 'formularios',
                name: 'formularios',
                meta: {
                    requiresAuth: true,
                    page: true,
                    nav: true,
                },
                props: true,
                component: () => import( /* webpackChunkName: "mafalda" */ '@/pages/formulario/PageFormularios')
            },

            {
                path: 'formulario/:id',
                name: 'formulario',
                meta: {
                    requiresAuth: true,
                    page: true,
                    nav: true,
                    menuVisible: false,
                    podeMinimizarMenu: true
                },
                component: () => import( /* webpackChunkName: "josefina" */ '@/pages/formulario/PageFormulario')
            },

            {
                path: 'formularios-dev',
                name: 'formularios-dev',
                meta: {
                    requiresAuth: true,
                    page: true,
                    nav: true,
                },
                props: true,
                component: () => import( /* webpackChunkName: "mafalda" */ '@/pages/formulario/PageFormularios')
            },
            {
                path: 'formularios-dev/:id',
                name: 'dev-formulario',
                meta: {
                    requiresAuth: true,
                    page: true,
                    nav: true,
                    menuVisible: false,
                },
                props: true,
                component: () => import( /* webpackChunkName: "marlene" */ '@/pages/dev/formulario/PageFormulario')
            },

            {
                path: 'consultassql',
                name: 'consultassql',
                meta: {
                    requiresAuth: true,
                    ajuda: {categoria: '86a4fe1a-6756-4ebf-9c94-0da8ac22a405'},
                    page: true,
                    nav: true,
                    somenteUsuarioDev: true,
                },
                component: () => import( /* webpackChunkName: "eugenia" */ '@/pages/consultaSql/PageConsultasSQL')
            },
            {
                path: 'origensdados',
                name: 'origensdados',
                meta: {
                    requiresAuth: true,
                    ajuda: {categoria: '86a4fe1a-6756-4ebf-9c94-0da8ac22a405'},
                    page: true,
                    nav: true,
                    somenteUsuarioDev: true,
                },
                component: () => import('@/pages/consultaSql/PageOrigensDeDados')
            },
            {
                path: 'consultasql/:id',
                name: 'consultasql',
                meta: {
                    requiresAuth: true,
                    rotaSalva: true,
                    ajuda: {categoria: '86a4fe1a-6756-4ebf-9c94-0da8ac22a405'},
                    page: false,
                    nav: true,
                    menuVisible: false,
                    podeMinimizarMenu: true,
                    isFullPage: false,
                    somenteUsuarioDev: true,
                },
                component: () => import( /* webpackChunkName: "filomena" */ '@/pages/consultaSql/PageConsultaSQL')
            },

            {
                path: 'requisicaoapi/:id',
                name: 'requisicaoapi',
                meta: {
                    requiresAuth: true,
                    rotaSalva: true,
                    page: false,
                    nav: true,
                    menuVisible: false,
                    podeMinimizarMenu: true,
                    isFullPage: false,
                    somenteUsuarioDev: true,
                },
                component: () => import('@/pages/requisicaoAPI/PageRequisicaoAPI')
            },
            {
                path: 'seletores',
                name: 'seletores',
                meta: {
                    requiresAuth: true,
                    rotaSalva: true,
                    ajuda: {categoria: '40d17770-4db2-4fb1-bfb3-effac14c86a7'},
                    page: true,
                    nav: true,
                    somenteUsuarioDev: true,
                },
                component: () => import( /* webpackChunkName: "genoveva" */ '@/pages/seletor/PageSeletores')
            },
            {
                path: 'perfisusuarios',
                name: 'perfisusuarios',
                meta: {
                    requiresAuth: true,
                    rotaSalva: true,
                    ajuda: {artigo: '48e1393d-415a-41cc-bc8f-6b7325a31c5a'},
                    page: true,
                    nav: true,
                },
                component: () => import( /* webpackChunkName: "matilda" */ '@/pages/perfilUsuario/PagePerfisUsuarios')
            },
            {
                path: 'perfisusuarios/:tipo/:id',
                name: "editarPerfil",
                component: () => import('@/pages/perfilUsuario/NovoPerfil')
            },
            {
                path: 'perfisusuarios/novo',
                name: "novoPerfil",
                component: () => import('@/pages/perfilUsuario/NovoPerfil'),
            },
            {
                path: "usuarios",
                children: [
                    {
                        path: "",
                        name: "usuarios",
                        component: () => import("@/pages/usuario/PageUsuarios.vue"),
                    },
                    {
                        path: "times",
                        name: "times",
                        component: () => import( /* webpackChunkName: "brigite" */  '@/pages/usuario/PageTimesUsuarios.vue'),
                    },
                ],
                component: () => import( /* webpackChunkName: "gentila" */ '@/pages/usuario/UsersLayout')
            },
            {
                path: 'usuarios/:id',
                name: "editarUsuario",
                component: () => import("@/pages/usuario/CreateUser.vue"),
            },
            {
                path: 'usuarios/novo',
                name: "novoUsuario",
                component: () => import("@/pages/usuario/CreateUser.vue"),
            },
            {
                path: "usuarios/times/:id",
                name: "timeEdit",
                component: () => import("@/pages/usuario/PageTimesEditar.vue"),
            },
            {
                path: 'empresas',
                name: 'empresas',
                meta: {
                    requiresAuth: true,
                    page: true,
                    nav: true,
                },
                component: () => import( /* webpackChunkName: "gema" */ '@/pages/empresa/PageEmpresas')
            },
            {
                path: 'snapshots',
                name: 'snapshots',
                meta: {
                    requiresAuth: true,
                    page: true,
                    nav: true,
                },
                component: () => import('@/pages/snapshots/Snapshots')
            },
            {
                path: 'snapshots/:id',
                name: 'snapshotsEdit',
                meta: {
                    requiresAuth: true,
                    page: true,
                    nav: true,
                },
                component: () => import('@/pages/snapshots/SnapshotDetail')
            },
            {
                path: 'configuracoes/geral',
                name: 'configuracoes',
                meta: {
                    requiresAuth: true,
                    ajuda: {artigo: 'df52b13e-589a-4d55-9c80-864469f0efa1'},
                    page: true,
                    nav: true
                },
                component: () => import( /* webpackChunkName: "janete" */ '@/pages/configuracoes/geral/PageGeral')
            },
            {
                path: 'agendamentos',
                children: [
                    {
                        path: '',
                        name: 'agendamentos',
                        meta: {
                            requiresAuth: true,
                            ajuda: {artigo: 'de4fdec9-f099-4911-9c38-29f559e29eec'},
                            page: true,
                            nav: true,
                        },
                        component: () => import( /* webpackChunkName: "ofelia" */ '@/pages/ferramentas/agendamento/PageAgendamentos')
                    },
                    {
                        path: 'alerta',
                        name: 'alertas',
                        meta: {
                            requiresAuth: true,
                            ajuda: {artigo: '38842e10-2698-4e38-8850-bda96984a821'},
                            page: true,
                            nav: true,
                        },
                        component: () => import( /* webpackChunkName: "ofelia" */ '@/pages/ferramentas/alerta/PageAlertas')
                    },
                ],
                component: () => import( /* webpackChunkName: "ofelia" */ '@/pages/ferramentas/AgendamentoAlertaLayout')
            },
            {
                path: 'agendamento/:id',
                name: 'agendamento',
                component: () => import( /* webpackChunkName: "ofelia" */ '@/pages/ferramentas/agendamento/PageAgendamento')
            },
            {
                path: 'agendamentos/alerta/:id',
                name: 'alerta',
                component: () => import( /* webpackChunkName: "ofelia" */ '@/pages/ferramentas/alerta/PageAlerta.vue')
            },
            {
                path: 'publicacoes',
                name: 'publicacoes',
                meta: {
                    requiresAuth: true,
                    ajuda: {artigo: 'bf72090b-f06d-4d7d-b9f6-06473d97a87e'},
                    page: true,
                    nav: true,
                },
                component: () => import( /* webpackChunkName: "gertrude" */ '@/pages/ferramentas/publicacoes/PagePublicacoes'),
            },
            {
                path: 'publicacoes/nova',
                name: 'novapublicacao',
                meta: {
                    requiresAuth: true,
                    page: true,
                    nav: true,
                },
                component: () => import("@/pages/dev/publicacao/NovaPublicacao"),
            },
            {
                path: 'importacaocenarios',
                name: 'importacaocenarios',
                meta: {
                    requiresAuth: true,
                    ajuda: {artigo: '5f53b170-8317-4234-9abf-f130f495d336'},
                    page: true,
                    nav: true,
                },
                component: () => import( /* webpackChunkName: "mariele" */ '@/pages/ferramentas/publicacoes/PageImportacaoCenarios')
            },
            {
                path: 'agendamentobackup',
                name: 'agendamentobackup',
                meta: {
                    requiresAuth: true,
                    ajuda: {artigo: '4d22c72a-6beb-4246-91a0-f40927622078'},
                    page: true,
                    nav: true,
                },
                component: () => import( /* webpackChunkName: "giselda" */ '@/pages/ferramentas/backup/PageAgendamentoBackup')
            },
            {
                path: 'traducaopaineis',
                name: 'traducaopaineis',
                ajuda: {artigo: '6750e92f-cfbc-4690-aa90-6434991d7966'},
                meta: {
                    requiresAuth: true,
                    page: true,
                    nav: true,
                },
                component: () => import( /* webpackChunkName: "minerva" */ '@/pages/ferramentas/traducaoPaineis/PageTraducaoPaineis')
            },
            {
                path: 'cabecalhoimpressao',
                name: 'cabecalhoimpressao',
                meta: {
                    requiresAuth: true,
                    ajuda: {artigo: '6750e92f-cfbc-4690-aa90-6434991d7966'},
                    page: true,
                    nav: true,
                },
                component: () => import( /* webpackChunkName: "jazida" */ '@/pages/ferramentas/cabecalhoImpressao/PageCabecalhoImpressao')
            },
            {
                path: 'logs',
                name: 'logs',
                meta: {
                    requiresAuth: true,
                    page: true,
                    nav: true,
                },
                component: () => import('@/pages/ferramentas/systemLogs/PageLogs')
            },
            {
                path: 'configuracoes/conexoesinternas',
                name: 'conexoesinternas',
                meta: {
                    requiresAuth: true,
                    page: true,
                    nav: true
                },
                component: () => import( /* webpackChunkName: "jandira" */ '@/pages/configuracoes/conexoesInternas/PageConexoesInternas')
            },
            {
                path: 'configuracoes/conexoesexternas',
                name: 'conexoesexternas',
                meta: {
                    requiresAuth: true,
                    rotaSalva: true,
                    ajuda: {artigo: 'cfd601d4-552f-47d6-a8f0-c22ed5680a14'},
                    page: true,
                    nav: true
                },
                component: () => import( /* webpackChunkName: "gizelda" */ '@/pages/configuracoes/conexoesExternas/PageConexoesExternas')
            },
            {
                path: 'configuracoes/conexoesexternas/:id',
                name: "editarConexao",
                component: () => import('@/pages/configuracoes/conexoesExternas/NovaConexao')
            },
            {
                path: 'configuracoes/conexoesexternas/nova',
                name: "novaConexao",
                component: () => import('@/pages/configuracoes/conexoesExternas/NovaConexao'),
            },
            {
                path: 'configuracoes/conexoesexternasusuarios',
                name: 'conexoesexternasusuarios',
                meta: {
                    requiresAuth: true,
                    page: true,
                    nav: true
                },
                component: () => import( /* webpackChunkName: "cremilda" */ '@/pages/configuracoes/conexoesExternasUsuarios/PageConexoesExternasUsuarios')
            },
            {
                path: 'configuracoes/conexoesexternasempresas',
                name: 'conexoesexternasempresas',
                meta: {
                    requiresAuth: true,
                    page: true,
                    nav: true
                },
                component: () => import( /* webpackChunkName: "felizberta" */ '@/pages/configuracoes/conexoesExternasEmpresas/PageConexoesExternasEmpresas')
            },
            {
                path: 'configuracoes/cadastrologos',
                name: 'cadastrologos',
                meta: {
                    requiresAuth: true,
                    page: true,
                    nav: true
                },
                component: () => import( /* webpackChunkName: "anastasia" */ '@/pages/configuracoes/cadastroLogos/PageCadastroLogos')
            },
            {
                path: 'configuracoes/email',
                name: 'configuraremail',
                meta: {
                    requiresAuth: true,
                    page: true,
                    nav: true
                },
                component: () => import( /* webpackChunkName: "marilin" */ '@/pages/configuracoes/email/PageConfiguracaoEmail')
            },
            {
                path: 'variaveisusuarios',
                name: 'variaveisusuarios',
                meta: {
                    requiresAuth: true,
                    ajuda: {artigo: '654430bd-f6f5-4983-96c7-fea3f1403fc5'},
                    page: true,
                    nav: true,
                },
                component: () => import( /* webpackChunkName: "tertulia" */ '@/pages/variavelUsuario/PageVariaveisUsuarios')
            },
            {
                path: 'perfilmobile',
                name: 'perfilmobile',
                meta: {
                    requiresAuth: true,
                    nav: true,
                    page: true
                },
                components: {viewInternaMobile: () => import( /* webpackChunkName: "firmina" */ '@/pages/usuario/PagePerfilMobile')}
            },
            {
                path: 'perfil',
                name: 'perfil',
                meta: {
                    requiresAuth: true,
                    nav: true,
                    page: true
                },
                component: () => import( /* webpackChunkName: "firmina" */ '@/pages/usuario/PagePerfil')
            },
            {
                path: 'paletadecores',
                name: 'paletaDeCores',
                meta: {
                    requiresAuth: true,
                    rotaSalva: true,
                    ajuda: {categoria: 'bd342537-97c6-4a6d-a1f9-495c51e71489'},
                    page: true,
                    nav: true,
                    somenteUsuarioDev: true,
                },
                component: () => import( /* webpackChunkName: "berengaria" */ '@/pages/dev/paleta/PagePaletas')
            },
            {
                path: 'traducao-sistema',
                name: 'traducao-sistema',
                meta: {
                    requiresAuth: false,
                    page: true,
                    nav: true,
                },
                component: () => import( /* webpackChunkName: "berenice" */ '@/pages/ferramentas/traducaoSistema/PageTraducaoSistema')
            },
            {
                path: 'traducao-sistema-conversao',
                name: 'traducao-sistema-conversao',
                meta: {
                    requiresAuth: false,
                    page: true,
                    nav: true,
                },
                component: () => import( /* webpackChunkName: "augusta" */ '@/pages/ferramentas/traducaoSistema/PageConversaoArquivos')
            },
            {
                path: ':pathMatch(.*)*',
                meta: {
                    requiresAuth: true,
                    page: true,
                    nav: true
                },
                component: () => import(/* webpackChunkName: "aparecida" */ '@/pages/_pageBase/NotFound')
            }
        ],
        component: () => import( /* webpackChunkName: "helga" */ '@/pages/_pageBase/VisPageBase')
    },
];

export const createRouterVistra = (app) => {

    const router = createRouter({
        base: '/',
        history: createWebHistory(import.meta.env.BASE_URL),
        routes,
        scrollBehavior: (to, from, savedPosition) => ({
            y: 0
        })
    })

    router.beforeEach(async (to, from, next) => {
        const store = app.config.globalProperties.$store

        if (to.meta.somenteUsuarioDev && store.getters.usuario.perfil !== 11) {
            app.config.globalProperties.$vistra.alert(app.config.globalProperties.$vistra.globalize("msg-sem-permissao-acesso"), app.config.globalProperties.$vistra.globalize("atencao"));
            return next('/')
        }

        if (to.path.startsWith('/go') && to.query.hasOwnProperty('autologin')) {
            store.commit("setIntegracao", true)
            store.commit("setTema", to.query.hasOwnProperty('dark') ? 'tema-dark' : 'tema')
        }

        if (to.path == '/login' && store.getters.integracao && !store.getters.permissaoSistemaCompletoIntegracao) {
            return next('/integracao-offline')
        }

        if (!to.meta.permiteIntegracao && to.path != '/login' && ![2, 3].includes(store?.getters?.usuario?.tipoUsuario)) {
            let responseConfigGeral = await app.config.globalProperties.$http.get('/Configuracoes/GetGeral')
            //verifica se realmente esta acessando via integração e sem permissao de acesso completo ao sistema
            //caso verdadeiro verifica a rota para dar permissao ao sistema ou deslogar
            if (responseConfigGeral?.data?.seguranca?.integracaoAutenticacao && !store?.getters?.permissaoSistemaCompletoIntegracao) {
                store.dispatch("logout")
                app.config.globalProperties.$vistra.showMessage("A instalação do vistra atual está com o modo autenticação por integração", "warning")
            }
        }


        // Verifica se o usuário está indo para outra página sem salvar o conteúdo editado
        if (store.getters.isLoggedIn && from.matched.some(record => record.meta.rotaSalva)) {
            if (store.getters.verificacaoRotaSalva) {
                await store.getters.verificacaoRotaSalva()
            }

            if (store.getters.rotaSalva) {
                next()
                return
            }
            store.commit('setNovaRota', to.path)
            store.commit('setConfirmarSalvarRota', true)
            next(false)
            return
        }

        let vai = () => {
            // Se estiver offline, somente algumas rotas devem continuar funcionando
            if (!store.getters.isOnline) {
                const isSnapshot = to.params && to.params.id && to.params.id.startsWith('s_')
                // Se a rota não funciona offline ou não é snapshot... 
                if (!(to.meta.funcionaOffline || isSnapshot)) {
                    // se quem chamou funciona offline, mantém nela
                    if (from.meta.funcionaOffline)
                        app.config.globalProperties.$vistra.showMessage(app.config.globalProperties.$vistra.globalize('precisa-estar-online'), "warning")
                    // senão, vai pra página dizendo que está offline
                    else
                        next("/offline")
                    return
                }
            }
            next()
        }
        if ((to.meta?.integracao || store.getters.permissaoSistemaCompletoIntegracao) || (to.path.startsWith('/painel/') && (to.query.hasOwnProperty('integracao') || to.query.hasOwnProperty('req'))))
            store.commit("setIntegracao", true);

        //if (to.matched.some(record => record.meta.requiresAuth && record.path !== '/')) {
        if (to.matched.some(record => record.meta.requiresAuth)) {
            if (store.getters.isLoggedIn) {
                
                if (store.getters.usuario.alterarSenhaProximoAcesso && !store.getters.integracao) {
                    next(`/resetarSenha/${store.getters.usuario.chaveResetarSenha}`)
                    return
                }
                
                vai()
                return
            }
            //redireciona pro link chamado antes do login
            if (to.matched.some(record => record.meta.rotaSalva)) {
                store.commit('setNovaRota', to.path)
                store.commit('setConfirmarSalvarRota', true)
            }
            next('/login')
        } else {
            vai()
        }
    })

    router.afterEach((to, from) => {
        window.onbeforeunload = undefined;
    })

    app.config.globalProperties.$router = router;

    return router;
}